<template>
  <v-card>
    <v-data-table
      :headers="headers"
      :search="search"
      :items="collections"
      :loading="loading"
      item-key="name"
      class="table-rounded datatable-height"
      fixed-header
      disable-sort
    >
      <template #[`item.img_collection`]="{ item }">
        <div class="icon-service center-sub-items">
          <img draggable="false" :src="loadImage(item.img_collection)" :alt="item.title" />
        </div>
      </template>
      <template #[`item.title`]="{ item }">
        <div class="d-flex flex-column">
          <span class="d-block font-weight-semibold text--primary text-truncate">{{ item.title }}</span>
          <!-- <small>{{ item.post }}</small> -->
        </div>
      </template>
      <template #[`item.buy_url`]="{ item }">
        <div class="d-flex flex-column">
          <a :href="item.buy_url">
            <v-icon color="green darken-2">{{ mdiCartVariant }} </v-icon>
          </a>
        </div>
      </template>
      <template #[`item.actions`]="{ item }">
        <div class="d-flex">
          <CrudButtons @edit="$emit('edit', item)" @remove="$emit('remove', item)"></CrudButtons>
        </div>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import CrudButtons from '@/components/buttons/CrudButtons.vue'
import { loadAPIImage } from '@/utils/images'
import { mdiCartVariant } from '@mdi/js'

export default {
  components: {
    CrudButtons,
  },
  props: {
    collections: Array,
    search: String,
    loading: Boolean,
  },
  setup() {
    const loadImage = src => {
      return loadAPIImage(src)
    }

    return {
      mdiCartVariant,
      loadImage,
      headers: [
        { text: 'IMAGEN', value: 'img_collection' },
        { text: 'COLLECCIÓN', value: 'title' },
        { text: 'LINK DE COMPRA', value: 'buy_url' },
        { text: '', value: 'actions', align: 'right' },
      ],
    }
  },
}
</script>

<style lang="scss" scoped>
.icon-service {
  padding: 10px;
  margin: 10px;
}

.icon-service img {
  max-width: 150px;
  max-height: 150px;
}

.center-sub-items {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>